/* eslint-disable quotes, quote-props, @typescript-eslint/quotes */
/* Auto-generated from inventory sequence definitions. */

export const SEQUENCE_CALCULATION_FORMULAS: Readonly<Record<string, Readonly<Record<string, string>>>> = {
	"BACKGROUND_COUNT_BARIUM": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_COUNT_CAESIUM": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_COUNT_COBALT": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_COUNT_IODINE": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_COUNT_TECHNETIUM": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_COUNT_INTEGRAL": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BOREHOLE_FACTOR": {
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BOREHOLE_FACTOR_PAYLOAD": {
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"value": "Quotient( Mean( record.activityProbeOne, record.activityProbeTwo, record.activityProbeThree ), Difference( record.activitySyringeFull, record.activitySyringeEmpty ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"LINEARITY_FLUORINE": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.initialValue, record.adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), record.adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), record.adjustedReferenceValue )",
		"adjustedExpectedValue": "record.adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), record.adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), record.adjustedReferenceValue )",
		"adjustedValue": "Undecay( record.value, record.recordedHours, F_9 )",
		"adjustedDeviation": "Difference( record.adjustedValue, record.adjustedExpectedValue )",
		"upperToleranceValue": "Decay( record.adjustedUpperToleranceValue, record.recordedHours, F_9 )",
		"upperReactionValue": "Decay( record.adjustedUpperReactionValue, record.recordedHours, F_9 )",
		"expectedValue": "Decay( record.adjustedExpectedValue, record.recordedHours, F_9 )",
		"lowerReactionValue": "Decay( record.adjustedLowerReactionValue, record.recordedHours, F_9 )",
		"lowerToleranceValue": "Decay( record.adjustedLowerToleranceValue, record.recordedHours, F_9 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"LINEARITY_TECHNETIUM": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.initialValue, record.adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), record.adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), record.adjustedReferenceValue )",
		"adjustedExpectedValue": "record.adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), record.adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), record.adjustedReferenceValue )",
		"adjustedValue": "Undecay( record.value, record.recordedHours, TC_99_M )",
		"adjustedDeviation": "Difference( record.adjustedValue, record.adjustedExpectedValue )",
		"upperToleranceValue": "Decay( record.adjustedUpperToleranceValue, record.recordedHours, TC_99_M )",
		"upperReactionValue": "Decay( record.adjustedUpperReactionValue, record.recordedHours, TC_99_M )",
		"expectedValue": "Decay( record.adjustedExpectedValue, record.recordedHours, TC_99_M )",
		"lowerReactionValue": "Decay( record.adjustedLowerReactionValue, record.recordedHours, TC_99_M )",
		"lowerToleranceValue": "Decay( record.adjustedLowerToleranceValue, record.recordedHours, TC_99_M )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"LINEARITY_V2_FLUORINE": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.meanAdjustedValue, record.adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), record.adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), record.adjustedReferenceValue )",
		"adjustedExpectedValue": "record.adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), record.adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), record.adjustedReferenceValue )",
		"adjustedValue": "Undecay( record.value, record.recordedHours, F_9 )",
		"adjustedDeviation": "Difference( record.adjustedValue, record.adjustedExpectedValue )",
		"upperToleranceValue": "Decay( record.adjustedUpperToleranceValue, record.recordedHours, F_9 )",
		"upperReactionValue": "Decay( record.adjustedUpperReactionValue, record.recordedHours, F_9 )",
		"expectedValue": "Decay( record.adjustedExpectedValue, record.recordedHours, F_9 )",
		"lowerReactionValue": "Decay( record.adjustedLowerReactionValue, record.recordedHours, F_9 )",
		"lowerToleranceValue": "Decay( record.adjustedLowerToleranceValue, record.recordedHours, F_9 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"LINEARITY_V2_TECHNETIUM": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"adjustedReferenceValue": "Fallback( memory.meanAdjustedValue, record.adjustedValue )",
		"adjustedUpperToleranceValue": "Product( Literal( 1.05 ), record.adjustedReferenceValue )",
		"adjustedUpperReactionValue": "Product( Literal( 1.03 ), record.adjustedReferenceValue )",
		"adjustedExpectedValue": "record.adjustedReferenceValue",
		"adjustedLowerReactionValue": "Product( Literal( 0.97 ), record.adjustedReferenceValue )",
		"adjustedLowerToleranceValue": "Product( Literal( 0.95 ), record.adjustedReferenceValue )",
		"adjustedValue": "Undecay( record.value, record.recordedHours, TC_99_M )",
		"adjustedDeviation": "Difference( record.adjustedValue, record.adjustedExpectedValue )",
		"upperToleranceValue": "Decay( record.adjustedUpperToleranceValue, record.recordedHours, TC_99_M )",
		"upperReactionValue": "Decay( record.adjustedUpperReactionValue, record.recordedHours, TC_99_M )",
		"expectedValue": "Decay( record.adjustedExpectedValue, record.recordedHours, TC_99_M )",
		"lowerReactionValue": "Decay( record.adjustedLowerReactionValue, record.recordedHours, TC_99_M )",
		"lowerToleranceValue": "Decay( record.adjustedLowerToleranceValue, record.recordedHours, TC_99_M )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"NUCLIDE_POSITION_ZERO_EFFECT": {
		"upperToleranceValue": "Product( Literal( 2 ), Maximum( Literal( 0.15 ), sequence.referenceValue ) )",
		"upperReactionValue": "Product( Literal( 1.5 ), Maximum( Literal( 0.15 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"NUCLIDE_POSITION_ZERO_EFFECT_802": {
		"upperToleranceValue": "Product( Literal( 2 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"NUCLIDE_POSITION_RESPONSIVENESS": {
		"recordedHours": "Hours( sequence.referenceDate, record.recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"expectedValue": "Decay( sequence.referenceValue, record.recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"MOLYBDENUM_BREAKTHROUGH_MOLYBDENUM": {
		"upperToleranceValue": "Literal( 0.1 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"MOLYBDENUM_BREAKTHROUGH_TECHNETIUM": {
		"upperToleranceValue": "Literal( 0.04 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"MOLYBDENUM_BREAKTHROUGH_PAYLOAD": {
		"upperToleranceValue": "Literal( 0.04 )",
		"expectedValue": "sequence.referenceValue",
		"value": "Percent( record.activityMolybdenum, record.activityTechnetium )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"POWER_WINDOW": {
		"upperToleranceValue": "Product( Literal( 1.04 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.02 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.98 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.96 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"POWER_WINDOW_PERCENTAGE": {
		"upperToleranceValue": "Literal( 4 )",
		"upperReactionValue": "Literal( 2 )",
		"expectedValue": "Literal( 0 )",
		"lowerReactionValue": "Literal( -2 )",
		"lowerToleranceValue": "Literal( -4 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"POWER_WINDOW_PERCENTAGE_V2": {
		"upperToleranceValue": "Sum( Literal( 4 ), sequence.referenceValue )",
		"upperReactionValue": "Sum( Literal( 2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Sum( Literal( -2 ), sequence.referenceValue )",
		"lowerToleranceValue": "Sum( Literal( -4 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"POWER_WINDOW_SETTING": {
		"upperToleranceValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.025 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.975 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, record.value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"expectedValue": "Decay( record.referenceValue, record.recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_BARIUM": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, record.value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), record.referenceValue ), record.recordedHours, BA_133 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), record.referenceValue ), record.recordedHours, BA_133 )",
		"expectedValue": "Decay( record.referenceValue, record.recordedHours, BA_133 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), record.referenceValue ), record.recordedHours, BA_133 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), record.referenceValue ), record.recordedHours, BA_133 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_CAESIUM": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, record.value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"expectedValue": "Decay( record.referenceValue, record.recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), record.referenceValue ), record.recordedHours, CS_137 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_COBALT": {
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_IODINE": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, record.value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), record.referenceValue ), record.recordedHours, I_129 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), record.referenceValue ), record.recordedHours, I_129 )",
		"expectedValue": "Decay( record.referenceValue, record.recordedHours, I_129 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), record.referenceValue ), record.recordedHours, I_129 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), record.referenceValue ), record.recordedHours, I_129 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_IODINE_V2": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, record.value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), record.referenceValue ), record.recordedHours, I_129 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), record.referenceValue ), record.recordedHours, I_129 )",
		"expectedValue": "Decay( record.referenceValue, record.recordedHours, I_129 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), record.referenceValue ), record.recordedHours, I_129 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), record.referenceValue ), record.recordedHours, I_129 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_STRONTIUM": {
		"recordedHours": "Hours( Fallback( memory.initialValueRecordedAt, record.recordedAt ), record.recordedAt )",
		"referenceValue": "Fallback( memory.initialValue, record.value )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), record.referenceValue ), record.recordedHours, SR_90 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), record.referenceValue ), record.recordedHours, SR_90 )",
		"expectedValue": "Decay( record.referenceValue, record.recordedHours, SR_90 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), record.referenceValue ), record.recordedHours, SR_90 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), record.referenceValue ), record.recordedHours, SR_90 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_TECHNETIUM": {
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_PAYLOAD": {
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.05 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.95 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.9 ), sequence.referenceValue )",
		"value": "Quotient( record.counts, record.activity )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"YIELD_PERCENT": {
		"upperToleranceValue": "Product( Literal( 1.08 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerToleranceValue": "Product( Literal( 0.92 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"GEOMETRY_FACTOR_DETERMINATION": {
		"upperToleranceValue": "Product( Literal( 1.15 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.075 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.925 ), sequence.referenceValue )",
		"lowerToleranceValue": "Product( Literal( 0.85 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"HOMOGENEITY": {
		"upperToleranceValue": "Literal( 7 )",
		"upperReactionValue": "Literal( 5 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 3 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY_V2": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 3 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY_V3": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 4 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"EXTRINSIC_HOMOGENEITY_V4": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Literal( 4 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"INTRINSIC_HOMOGENEITY": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 3 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"INTRINSIC_HOMOGENEITY_V2": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Minimum( Literal( 4 ), Product( Literal( 1.5 ), sequence.referenceValue ) )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"INTRINSIC_HOMOGENEITY_V3": {
		"upperToleranceValue": "Literal( 5 )",
		"upperReactionValue": "Literal( 4 )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"HOMOGENEITY_WITHOUT_CORRECTION_MATRIX": {
		"upperToleranceValue": "Product( Literal( 1.1 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.08 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CARTRIDGE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( record.activityElution, Sum( record.activityElution, record.activityCartridge ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_FILTER": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( record.fractionB, Sum( record.fractionA, record.fractionB, record.fractionC ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_RINSED_FILTER": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"value": "Percent( record.fractionB, record.fractionA )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_TLC_SCANNER": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_B20_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_CARDIOTOP_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_DMSA_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 98 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_DTPA_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_EHIDA_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_MAG3_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_MDP_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_NANO_HSA_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_NEUROSPECT_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 80 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_TEKTROTYD_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_ROTOP_TETROFOSMIN_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_NANOCIS_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_NEUROLITE_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_PULMOCIS_FILTER": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 90 )",
		"value": "Percent( record.activityElution, Sum( record.activityElution, record.activityFilter ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_SCINTIMUN_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_STAMICIS_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_STAMICIS_CARTRIDGE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( record.activityElution, Sum( record.activityElution, record.activityCartridge ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECEOS_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECEOS_DOUBLE_STRIPE_2024": {
		"methodOneValue": "Percent( record.methodOneActivityStart, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityFront, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_DSMA_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_DTPA_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_HDP_DOUBLE_STRIPE": {
		"methodOneValue": "Percent( record.methodOneActivityFront, Sum( record.methodOneActivityStart, record.methodOneActivityFront ) )",
		"methodTwoValue": "Percent( record.methodTwoActivityStart, Sum( record.methodTwoActivityStart, record.methodTwoActivityFront ) )",
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Difference( record.expectedValue, Sum( record.methodOneValue, record.methodTwoValue ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_MAG3_CARTRIDGE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 95 )",
		"value": "Percent( record.activityElutionTwo, Sum( record.activityElutionOne, record.activityElutionTwo, record.activityCartridge ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_MAG3_CARTRIDGE_V2": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( record.activityElutionTwo, Sum( record.activityElutionOne, record.activityElutionTwo, record.activityCartridge ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_SESTAMIBI_SINGLE_STRIPE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( record.activityStart, Sum( record.activityStart, record.activityFront ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RP_CURIUM_TECHNESCAN_SESTAMIBI_CARTRIDGE": {
		"expectedValue": "Literal( 100 )",
		"lowerToleranceValue": "Literal( 94 )",
		"value": "Percent( record.activityElution, Sum( record.activityElution, record.activityCartridge ) )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"CTDI": {
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.8 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"CTDI_CUSTOM": {
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_FWHM_AVERAGE": {
		"upperReactionValue": "Literal( 19 )",
		"expectedValue": "Literal( 9.5 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_LARGEST_MAX_MIN_DELTA_TILT": {
		"upperReactionValue": "Literal( 2 )",
		"expectedValue": "Literal( 1 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_MAX_BASELINE_DIFFERENCE": {
		"upperReactionValue": "Literal( 7 )",
		"expectedValue": "Literal( 3.5 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_GEMINI_SUV_VALIDATION_AND_HOMOGENITY": {
		"upperReactionValue": "Literal( 1.1 )",
		"expectedValue": "Literal( 1 )",
		"lowerReactionValue": "Literal( 0.9 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_AXIAL_ABERRANCE": {
		"upperReactionValue": "Literal( 5 )",
		"expectedValue": "Literal( 2.5 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_ENERGY_TEST_AVERAGE_CENTROID": {
		"upperReactionValue": "Literal( 140 )",
		"expectedValue": "Literal( 106 )",
		"lowerReactionValue": "Literal( 68 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_ENERGY_TEST_AVERAGE_ENERGY_RESOLUTION": {
		"upperReactionValue": "Literal( 13 )",
		"expectedValue": "Literal( 7 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_INTEGRAL_HOMOGENITY": {
		"upperReactionValue": "Literal( 2.5 )",
		"expectedValue": "Literal( 1.25 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_MID_SUV_OF_HOMOGENITY": {
		"upperReactionValue": "Literal( 1.05 )",
		"expectedValue": "Literal( 1 )",
		"lowerReactionValue": "Literal( 0.95 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_MID_SUV_OF_HOMOGENITY_BRAIN": {
		"upperReactionValue": "Literal( 1.1 )",
		"expectedValue": "Literal( 1 )",
		"lowerReactionValue": "Literal( 0.9 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_TIMING_RESOLUTION": {
		"upperReactionValue": "Literal( 450 )",
		"expectedValue": "Literal( 225 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_PHILIPS_VEREOS_UNIFORMITY_TEST_BAD_PIXELS": {
		"upperReactionValue": "Literal( 160 )",
		"expectedValue": "Literal( 80 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_BLOCK_EFFICIENCY": {
		"upperReactionValue": "Literal( 120 )",
		"expectedValue": "Literal( 100 )",
		"lowerReactionValue": "Literal( 80 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_BLOCK_NOISE": {
		"upperReactionValue": "Literal( 10 )",
		"expectedValue": "Literal( 5 )",
		"lowerReactionValue": "Literal( 0 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_MEASURED_RANDOMS": {
		"upperReactionValue": "Literal( 115 )",
		"expectedValue": "Literal( 100 )",
		"lowerReactionValue": "Literal( 85 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_SCANNER_EFFICIENCY": {
		"upperReactionValue": "Product( Literal( 1.3 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.7 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"PET_CT_SIEMENS_GENERIC_SCATTER_RATIO": {
		"upperReactionValue": "Product( Literal( 1.3 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "Product( Literal( 0.7 ), sequence.referenceValue )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_ZERO_EFFECT": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"upperReactionValue": "Product( Literal( 1.2 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_ZERO_EFFECT_V2": {
		"upperToleranceValue": "Product( Literal( 1.5 ), sequence.referenceValue )",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"BACKGROUND_ZERO_EFFECT_FREE": {
		"upperToleranceValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RESPONSIVENESS": {
		"recordedHours": "Hours( sequence.referenceDate, record.recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.15 ), sequence.referenceValue ), record.recordedHours, CO_57 )",
		"upperReactionValue": "Decay( Product( Literal( 1.1 ), sequence.referenceValue ), record.recordedHours, CO_57 )",
		"expectedValue": "Decay( sequence.referenceValue, record.recordedHours, CO_57 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.9 ), sequence.referenceValue ), record.recordedHours, CO_57 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.85 ), sequence.referenceValue ), record.recordedHours, CO_57 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RESPONSIVENESS_CS_137": {
		"recordedHours": "Hours( sequence.referenceDate, record.recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"expectedValue": "Decay( sequence.referenceValue, record.recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"RESPONSIVENESS_CS_137_V2": {
		"recordedHours": "Hours( sequence.referenceDate, record.recordedAt )",
		"upperToleranceValue": "Decay( Product( Literal( 1.05 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"upperReactionValue": "Decay( Product( Literal( 1.03 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"expectedValue": "Decay( sequence.referenceValue, record.recordedHours, CS_137 )",
		"lowerReactionValue": "Decay( Product( Literal( 0.97 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"lowerToleranceValue": "Decay( Product( Literal( 0.95 ), sequence.referenceValue ), record.recordedHours, CS_137 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"HELIUM_LEVEL": {
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"LOW_CONTRAST_OBJECTS": {
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"LINE_RESOLUTION": {
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"DOSE_SURFACE_PRODUCT_ABSOLUTE": {
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"DOSE_SURFACE_PRODUCT_RELATIVE": {
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"DOSE_INDICATOR": {
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerReactionValue": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"EDGE_DEVIATION": {
		"upperReactionValue": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"GENERIC_CUSTOM": {
		"upperThreshold": "sequence.upperThreshold",
		"expectedValue": "sequence.referenceValue",
		"lowerThreshold": "sequence.lowerThreshold",
		"deviation": "Difference( record.value, record.expectedValue )"
	},
	"FREE_TEXT": {
	},
	"SINGLE_SELECT": {
	},
	"CHECK": {
	},
	"OBJECTIVE": {
		"upperThreshold": "sequence.upperThreshold",
		"expectedValue": "Literal( 0 )",
		"deviation": "Difference( record.value, record.expectedValue )"
	}
} as const;

export const getSequenceCalculationFormula = (sequenceType: string, fieldName: string): string | null => {
	return SEQUENCE_CALCULATION_FORMULAS[sequenceType]?.[fieldName] ?? null;
};
